import * as DialogPrimitive from '@radix-ui/react-dialog';
import { ForwardedRef, ReactNode } from 'react';
import styled from 'styled-components';
import { coreTokens } from '../../core';
import { theme } from './dialog_modal.theme';

const elements = {
	header: styled(DialogPrimitive.Title)`
		font: ${theme.getValue('titleFont')};
		margin: 0;
		padding-right: ${coreTokens.spacing.x3};

		${coreTokens.breakpointQuery.medium} {
			font: ${theme.getValue('titleFontAtMediumAndAbove')};
		}
	`,
};

export interface DialogModalTitleProps {
	children: ReactNode;
}

export function DialogModalTitle({ children }: DialogModalTitleProps, ref: ForwardedRef<HTMLDivElement>): JSX.Element {
	return <elements.header ref={ref}>{children}</elements.header>;
}
